import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { JqueryUtils } from '../../utils/jquery.utils';
import { AccountService } from '../../services/api/account.service';

import { NotificationService } from '../../services/notification.service';
import { CONSTANTS } from '../../constants';
// import { MAT_DATE_FORMATS } from '@angular/material/core';
import 'rxjs';
import { DataService } from '../../services/data.service';

// export const MY_DATE_FORMATS = {
//   parse: {
//     dateInput: 'DD/MM/YYYY',
//   },
//   display: {
//     dateInput: 'YYYY-MM-DD',
//     monthYearLabel: 'MMMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY'
//   },
// };
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  providers: [
    // { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class UsersComponent implements OnInit {

  offset = 0;
  count = 20;
  totalPages = 0;
  totalItems = 0;
  selectedItemPerPage = 0;
  pageNumber = 0;

  users: any[] = [];
  modalHeader = '';
  modal_user: any = {};
  cm_params: any = { };
  admin: any;

  user_modal_form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
    phone: new FormControl('', [Validators.required, Validators.pattern("[0-9 ]{10}")]),
    subscription_upto: new FormControl(''),
    password: new FormControl('', [Validators.required])
  });

  constructor(private accountService: AccountService, private dataService: DataService,
    private jq: JqueryUtils, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.USERS});
    this.listUsers();
  }

  listUsers(data = {}) {
    this.accountService.listAccounts().subscribe((response: any) => {
      let accs = response.accounts;
      let users = [];
      let acc;
      for (let idx = 0; idx < accs.length; idx++) {
        acc = accs[idx];
        if (acc.state == 'active') {
          acc.state_class = { 'bi-person-check-fill': 1, 'bi-person-fill': 0, 'text-success': 1 }
        } else {
          acc.state_class = { 'bi-person-check-fill': 0, 'bi-person-fill': 1, 'text-success': 0 }
        }
        users.push(acc);
      }
      this.users = users;
    });
  }

  onActivate(account: any) {
    this.cm_params = {
      msg: `Are you sure want to ${account.state == 'active' ? 'deactivate' : 'activate'} this user ?`,
      tag: account.user.full_name,
      btn_text: (account.state == 'active') ? 'DEACTIVATE' : 'ACTIVATE',
      btn_class: (account.state == 'active') ? {'btn-success': 0, 'btn-danger':1} : {'btn-success': 1, 'btn-danger':0},
      action: 'activate',
      details: {
        _id: account._id,
        state: (account.state == 'active') ? 0 : 1
      }
    }
    this.jq.openModal('confirmationModal');
  }

  saveUser() {
    if (this.modal_user.mode == 'add') {
      let data = {
        user: {
          full_name: this.user_modal_form.value.name,
          email: this.user_modal_form.value.email,
          phone: this.user_modal_form.value.phone,
          password: this.user_modal_form.value.password,
        },
        subscription_upto: this.user_modal_form.value.subscription_upto
      }
      this.accountService.addAccount(data).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.jq.closeModal('accountModal');
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "User added successfully")
          this.listUsers();
        }
      });
    } else if (this.modal_user.mode == 'edit') {
      let data = { 
        account_id: this.modal_user.account._id,
        user: {
          _id: this.modal_user._id,
          full_name: this.user_modal_form.value.name,
          email: this.user_modal_form.value.email,
          phone: this.user_modal_form.value.phone,
          password: this.user_modal_form.value.password,
        },
        subscription_upto: this.user_modal_form.value.subscription_upto
      };
      this.accountService.updateAccount(data).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.jq.closeModal('accountModal');
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "User updated successfully")
          this.listUsers();
        }
      });
    }
  }

  onAdd() {
    this.modalHeader = 'Add User';
    this.modal_user = { header: 'Add User', btn_text: 'ADD', mode: 'add' };
    this.user_modal_form.patchValue({
      name: '',
      email: '',
      phone: '',
      subscription_upto: ''
    });
    this.user_modal_form.controls['password'].setValidators([Validators.required]);
    this.user_modal_form.controls['password'].updateValueAndValidity();
    this.jq.openModal('accountModal');
  }

  onUpdate(account: any) {
    this.modal_user = account.user;
    this.modal_user['mode'] = 'edit';
    this.modal_user['header'] = 'Update User';
    this.modal_user['btn_text'] = 'UPDATE';
    this.modal_user['account'] = account;
    this.modal_user['_id'] = account.user._id;
    this.user_modal_form.patchValue({
      name: account.user.full_name,
      email: account.user.email,
      phone: account.user.phone,
      subscription_upto: account.subscription_upto
    });
    this.user_modal_form.controls['password'].setValidators(null);
    this.user_modal_form.controls['password'].updateValueAndValidity();
    this.jq.openModal('accountModal');
  }

  onModalClose(modal_name: string) {
    if (modal_name == 'account') {
      this.modal_user = { header: '', btn_text: '', name: '', email: '', phone: '', subscription_upto: '', password: '' };
      this.jq.closeModal('accountModal');
    } else if (modal_name == 'confirmation') {
      this.jq.closeModal('confirmationModal');
    }
  }

  onDelete(account: any) {
    this.cm_params = {
      msg: 'Are you sure want to delete this user ?',
      tag: account.user.full_name,
      btn_text: 'DELETE',
      action: 'delete',
      details: {
        _id: account._id
      }
    }
    this.jq.openModal('confirmationModal');
  }

  onConfirm() {
    if (this.cm_params.action == 'delete') {
      let input = { "_id": this.cm_params.details._id };
      this.accountService.deleteAccount(input).subscribe((response: any) => {
        this.cm_params = { };
        this.jq.closeModal('confirmationModal');
        this.notificationService.showAlert(CONSTANTS.SUCCESS, "User deleted successfully");
        this.listUsers();
      });
    } else if (this.cm_params.action == 'activate') {
      let input = { "_id": this.cm_params.details._id, "state": this.cm_params.details.state };
      this.accountService.activateAccount(input).subscribe((response: any) => {
        if (this.cm_params.details.state == 1) {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "User Activated successfully");
        } else {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "User Deactivated successfully");
        }
        this.cm_params = { };
        this.jq.closeModal('confirmationModal');
        this.listUsers();
      });
    }
  }

  get name() {
    return this.user_modal_form.get('name') as FormControl
  }

  get name_errors() {
    return (this.user_modal_form.get('name') as FormControl).errors as ValidationErrors
  }

  get email() {
    return this.user_modal_form.get('email') as FormControl
  }

  get email_errors() {
    return (this.user_modal_form.get('email') as FormControl).errors as ValidationErrors 
  }

  get phone() {
    return this.user_modal_form.get('phone') as FormControl
  }

  get phone_errors() {
    return (this.user_modal_form.get('phone') as FormControl).errors as ValidationErrors
  }

  get password() {
    return this.user_modal_form.get('password') as FormControl
  }

  get password_errors() {
    return (this.user_modal_form.get('password') as FormControl).errors as ValidationErrors
  }

  next() { }
  prev() { }
}
